import { useCurrentOrganization } from "app/core/hooks/useCurrentOrganization"

import { organizationHasSchoolyears } from "utils/schoolyears/organizationHasSchoolyears"

export const useHasSchoolyears = () => {
  const organization = useCurrentOrganization()
  if (!organization) return false
  return organizationHasSchoolyears(organization)
}
